
<template>
  <div id="app">
	  <div v-cloak>
       <Rcv />

	  </div>
 
	  
  </div>

 
</template>


<script>

import Rcv from './Rcv'
import   '../styles/styles.scss'


export default {
  name: "App",
  components: {
  "Rcv":  Rcv,
  },
};
</script>




// WEBPACK FOOTER //
// src/App.vue